import { useSyncExternalStore } from 'react';
import {
  locationEngine,
  type LocationCoords,
  type LocationMarkerData,
  type LocationPermissionStatus,
  type LocationSnapshot,
  type MovementMode,
} from '../services/locationEngine';

/** Live coordinates only — re-renders exclusively when lat/lng actually change. */
export function useLocationCoords(): LocationCoords | null {
  return useSyncExternalStore(locationEngine.subscribe, locationEngine.getCoords);
}

/** Combined {latitude, longitude, heading, accuracy} for the map marker — one subscription. */
export function useLocationForMap(): LocationMarkerData | null {
  return useSyncExternalStore(locationEngine.subscribe, locationEngine.getMarkerData);
}

export function useMovementMode(): MovementMode {
  return useSyncExternalStore(locationEngine.subscribe, locationEngine.getMovementMode);
}

export function useIsTracking(): boolean {
  return useSyncExternalStore(locationEngine.subscribe, locationEngine.getIsTracking);
}

export function useLocationPermission(): LocationPermissionStatus {
  return useSyncExternalStore(locationEngine.subscribe, locationEngine.getPermissionStatus);
}

/**
 * One-off imperative read — for recenter taps, "Nearby" chip toggles, or any
 * future one-time persistence effect. Never subscribe live for anything that
 * writes to Firestore; always snapshot once via this function instead.
 */
export function getLocationSnapshot(): LocationSnapshot {
  return locationEngine.getSnapshot();
}

/** Idempotent — re-checks/re-requests permission (e.g. user retrying after a denial). */
export function ensureLocationPermission(): Promise<LocationPermissionStatus> {
  return locationEngine.ensureLocationPermission();
}
